import computeTagName from '../../../utils/computeTagName';
import computeClassName from '../../../utils/computeClassName';

const constants = Object.freeze({
  TAG_DEFAULT: 'section',
  CLASSNAME_BASE: 'cc-c-container',
  CLASSNAME_IS_CENTERED: {
    true: 'cc-c-container--centered',
    false: ''
  }
});

const propsDefaults = Object.freeze({
  isCentered: true,
  tag: constants.TAG_DEFAULT,
});

function getComputedClassName(propsClassName, isCentered) {
  return computeClassName(propsClassName, `${constants.CLASSNAME_BASE} ${constants.CLASSNAME_IS_CENTERED[isCentered]}`);
}

export default function Container(
  {
    isCentered= propsDefaults.isCentered,
    tag = propsDefaults.tag,
    className = '',
    children
  }
) {
  const ComputedTagName = computeTagName(tag, constants.TAG_DEFAULT);
  const computedClassName = getComputedClassName(className, isCentered);
  return (
    <ComputedTagName className={computedClassName}>
        {children}
    </ComputedTagName>
  );
}
